const journeyTl = gsap.timeline({ paused: true });
const journeyST = ScrollTrigger.create({
  trigger: '.home-journey',
  start: 'top 75%',
  // end: 'bottom 50%',
  animation: journeyTl,
})

journeyTl.fromTo('.line-indigo', { 
  drawSVG: '100% 100%'
}, {
  drawSVG: '100% 0%',
  duration: 7
})